import {addEditCountryActionTypes} from "../constants/AddEditActionConstants";
import _ from "lodash";


const initialState = {
    editCountry: false,
    toggleModal: false,
    updatedCountry: false,
    countryObject: {
        age_support: false,
        bv_support: false,
        bv_plus_support: false,
        country_iso: "",
        country_name: "",
        created_date: "",
        id: "",
        is_deleted: false,
        kyc_status: "",
        kyc_tier: "",
        last_updated: "",
        number_1x1_match_rate: 0,
        number_2x2_match_rate: 0,
        number_2x2_support: false,
    },
    notesObject: [
        {
            note: "",
            notes_id: null,
            resource_id: "",
            type: "Internal"
        },
        {
            note: "",
            notes_id: null,
            resource_id: "",
            type: "External"
        },
    ],
}

const addEditCountryReducer = (state = initialState, action) => {
    switch (action.type) {

        case addEditCountryActionTypes.EDIT_ONE_COUNTRY: {
            let newState = _.cloneDeep(state);
            newState.editCountry = !initialState.editCountry;
            newState.toggleModal = !initialState.toggleModal;
            newState.countryObject = action.payload.countryDetail.country_detail;
            newState.notesObject = action.payload.countryDetail.notes;
            return newState;
        }

        case addEditCountryActionTypes.ADD_COUNTRY: {
            let newState = _.cloneDeep(state);
            newState.toggleModal = !initialState.toggleModal;
            return newState;
        }

        case addEditCountryActionTypes.TOGGLE_MODAL: {
            return initialState;
        }

        case addEditCountryActionTypes.UPDATED_COUNTRY_REFRESH:{
            let newState = _.cloneDeep(state);
            newState.updatedCountry = !newState.updatedCountry;
            return newState;
        }

        case "UPDATE_NOTES": {
            let newState = _.cloneDeep(state);
            newState.notesObject.forEach(note => {
                if (note.type === action.payload.name) {
                    note.note = action.payload.value
                }
            });
            return newState;
        }

        case addEditCountryActionTypes.SET_COUNTRY: {
            let newState = _.cloneDeep(state);
            if (action.payload.country === null) {
                newState.countryObject.country_iso = initialState.countryObject.country_iso;
                newState.countryObject.country_name = initialState.countryObject.country_name;
            } else {
                newState.countryObject.country_iso = action.payload.country.value;
                newState.countryObject.country_name = action.payload.country.label;
            }
            return newState;
        }

        case addEditCountryActionTypes.SET_COUNTRY_PRODUCT_SUPPORT: {
            let newState = _.cloneDeep(state);
            newState.countryObject[action.payload.product_type] = !newState.countryObject[action.payload.product_type];
            return newState;
        }

        case addEditCountryActionTypes.SET_COUNTRY_DROPDOWNS: {
            let newState = _.cloneDeep(state);

            if (action.payload.option === null) {
                newState.countryObject[action.payload.change_obj.name] = initialState.countryObject[action.payload.change_obj.name];
                } else {
                newState.countryObject[action.payload.change_obj.name] = action.payload.option.value;
            }
            return newState;
        }

        case addEditCountryActionTypes.SET_MATCH_RATES: {
            let newState = _.cloneDeep(state);
            // reject character input/empty string
             if (action.payload.value === "") {
                newState.countryObject[action.payload.name] = initialState.countryObject[action.payload.name]
            } else {
                newState.countryObject[action.payload.name] = parseInt(action.payload.value);
            }
            return newState;
        }

        default:
            return state;
    }
}

export default addEditCountryReducer;
